import { useState } from 'react';
import Container from 'components/common/container';
import Drawer from 'components/common/drawer';
import { useLanguage } from 'core/hooks';

import Bookmarks from './Bookmarks';
import BooksViewer from './BooksViewer';
import Header from './Header';

import './style.scss';

function Bible() {
  const { currentLanguage } = useLanguage();
  const [isBookmarkDrawerOpen, setIsBookmarkDrawerOpen] = useState(false);

  const handleShowBookmarkDrawer = () => {
    setIsBookmarkDrawerOpen(true);
  };

  const handleCloseBookmarkDrawer = () => {
    setIsBookmarkDrawerOpen(false);
  };

  return (
    <Container px={0} fluid>
      <Header onShowBookmarkDrawer={handleShowBookmarkDrawer} />
      <div className="bible-v2-container">
        <BooksViewer />
      </div>
      <Drawer
        className="bible__bookmarks-drawer"
        placement="left"
        open={isBookmarkDrawerOpen}
        title={currentLanguage.bookmarks}
        onClose={handleCloseBookmarkDrawer}
      >
        <Bookmarks />
      </Drawer>
    </Container>
  );
}

export default Bible;
